import {put, takeEvery, select} from 'redux-saga/effects';
import {sparePartsWebsocketCommands} from '../../constants/sparePartsWebsocketCommands';
import {push} from 'react-router-redux';
import {SPARE_PARTS_RESET} from '../../actions/orders/actionTicket';
import get from 'get-value';

export function* handleTicketError(action) {
    const stateCorrelationId = get(yield select(state => state.sparePartsOrderTicket), `correlationId`, {default: undefined});
    const {correlationId} = action.payload;
    if (correlationId < stateCorrelationId) {
        return;
    }
    yield put(push('/order'));
    yield put({type: SPARE_PARTS_RESET});
}

function* sparePartsTicketSaga() {
    yield takeEvery(sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_TICKET_UPDATE_FATAL, handleTicketError);
    yield takeEvery(sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_TICKET_CREATE_FATAL, handleTicketError);
    yield takeEvery(sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_TICKET_SEND_ERROR, handleTicketError);
}

export default sparePartsTicketSaga;
